import { makeStyles } from "@mui/styles";

import type { Theme } from "src/theme";

const TEXT_COLOR_UBEREATS = "#23A620";
const TEXT_COLOR_DELIVEROO = "#2AE1D6";
const BACKGROUND_COLOR_UBEREATS = "#F7FCF7";
const BACKGROUND_COLOR_DELIVEROO = "#F3FBFB";

export const useAdminMonitoringStyles = makeStyles((theme: Theme) => ({
    cardOne: {
        padding: theme.spacing(4),
        marginTop: theme.spacing(5),
    },
    cardTwo: {
        padding: theme.spacing(4),
        marginTop: theme.spacing(2),
    },
    alertCard: {
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(4),
    },
    alertCardHeader: {
        cursor: "pointer",
        padding: theme.spacing(4),
        width: "100%",
        display: "flex",
        alignItems: "center",
        transition: "ease 0.3s",
        "&:hover": {
            background: "rgb(245,245,245)",
        },
    },
    alertCardContent: {
        width: "100%",
        borderBottom: "1px solid rgb(245,245,245)",
        paddingLeft: theme.spacing(8),
        paddingRight: theme.spacing(8),
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        display: "flex",
        alignItems: "center",
    },
    chevronIcon: {
        marginLeft: "auto",
        marginRight: 0,
        fontSize: 24,
    },
    warningIcon: {
        color: "orange",
        fontSize: 32,
        marginRight: theme.spacing(1),
    },
    errorIcon: {
        color: "red",
        fontSize: 32,
        marginRight: theme.spacing(1),
    },
    textInfo: {
        marginRight: theme.spacing(2),
        color: "grey",
    },
    infosContainer: {
        marginLeft: "auto",
        marginRight: "auto",
        display: "flex",
        alignItems: "center",
    },
    cardContentTitle: {
        fontWeight: "bold",
        lineHeight: "2em",
    },
    cardContentSubText: {
        display: "block",
        color: "grey",
    },
    cardContentAlertContainer: {
        height: "100%",
        marginRight: theme.spacing(2),
    },
    cardContentTextContainer: {
        maxWidth: 600,
    },
    collapseContainer: {
        minWidth: 50,
    },
    solveButtonContainer: {
        marginLeft: "auto",
        marginRight: 0,
    },
    timeAndLabelContainer: {
        display: "flex",
        marginLeft: "auto",
        marginRight: 0,
    },
    timeLabelContainer: {
        marginRight: theme.spacing(),
    },
    timeContainer: {
        marginLeft: "auto",
        marginRight: 0,
    },
    divider: {
        marginBottom: theme.spacing(2),
    },

    refreshOrganizationBox: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    refreshOrganizationButtonContainer: {
        textAlign: "center",
    },
    refreshOrganizationDisplaySearchButton: {
        marginBottom: 0,
    },
    refreshOrganizationTitle: {
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
    refreshOrganizationSubTitle: {
        fontSize: 10,
        marginBottom: theme.spacing(2),
    },
    refreshOrganizationTextField: {
        marginBottom: theme.spacing(2),
    },
    refreshOrganizationButton: {
        width: "50%",
        marginBottom: theme.spacing(2),
    },
    marginBottom: {
        marginBottom: theme.spacing(3),
    },
    colorTextUberEats: {
        color: TEXT_COLOR_UBEREATS,
    },
    colorTextDeliveroo: {
        color: TEXT_COLOR_DELIVEROO,
    },
    backgroundUberEats: {
        backgroundColor: BACKGROUND_COLOR_UBEREATS,
    },
    backgroundDeliveroo: {
        backgroundColor: BACKGROUND_COLOR_DELIVEROO,
    },
    subtitle: {
        margin: theme.spacing(2),
    },
    alignItemsCenter: {
        display: "flex",
        alignItems: "center",
    },
}));
